<template>
  <v-card v-if="!selectDay" flat class="picker">
    <v-card-title class="d-flex justify-space-between pa-1 ma-0 picker-header">
      <v-btn @click="moveBack()" :disabled="checkMin" icon
        ><v-icon>chevron_left</v-icon></v-btn
      >

      <span class="a-title a-bold select-day" @click="selectDay = !selectDay"
        >{{ selectedDay }}
      </span>
      <v-btn @click="moveFoward()" :disabled="checkMax" icon
        ><v-icon>chevron_right </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <div class="d-flex row justify-center">
        <TimeComponentPickerHourly v-model="initialHour" :color="color" />
        <div class="d-flex align-center mr-3 ml-3">:</div>
        <TimeComponentPickerHourly
          type="minutes"
          v-model="initialMinutes"
          :color="color"
        />
      </div>
      <div class="d-flex row justify-center mt-6">
        <TimeComponentPickerHourly
          :initialValue="23"
          :color="color"
          v-model="finalHour"
        />
        <div class="d-flex align-center mr-3 ml-3">:</div>

        <TimeComponentPickerHourly
          :initialValue="59"
          :color="color"
          type="minutes"
          v-model="finalMinutes"
        />
      </div>
    </v-card-text>
  </v-card>
  <v-date-picker
    v-model="selectedDay"
    v-else
    no-title
    :color="color"
    type="date"
    :max="max"
  ></v-date-picker>
</template>

<script>
import moment from "moment";
import TimeComponentPickerHourly from "./TimeComponentPickerHourly.vue";
export default {
  components: {
    TimeComponentPickerHourly,
  },
  props: {
    initialDate: [String, Array],
    color: { type: String, default: "green lighten-1" },
    range: { type: Boolean, default: true },
    max: {
      type: [String, Object],
      default: new Date().toISOString(),
    },
    min: {
      type: [String, Object],
      default: undefined,
    },
  },
  data() {
    return {
      initialHour: 0,
      initialMinutes: 0,
      finalHour: 0,
      finalMinutes: 0,
      selectDay: undefined,
      selectedDay: moment().format("YYYY-MM-DD"),
      date: [],
    };
  },
  watch: {
    selectedDay() {
      if (this.selectedDay) this.selectDay = false;
    },
    selectedDate() {
      this.date = this.range ? this.selectedDate : this.selectedDate[0];
      this.$emit("input", this.date);
    },
  },
  mounted() {
    if (this.initialDate) {
      this.selectedDay =
        this.initialDate[0].length > 1
          ? moment(this.initialDate[0]).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
      this.date = this.initialDate;
    }
  },
  computed: {
    startDate() {
      let initialHour = this.initialHour < 10 ? `0${this.initialHour}` : this.initialHour;
      let initialMinutes =
        this.initialMinutes < 10 ? `0${this.initialMinutes}` : this.initialMinutes;

      return `${this.selectedDay}T${initialHour}:${initialMinutes}:00`;
    },
    endDate() {
      let finalHour = this.finalHour < 10 ? `0${this.finalHour}` : this.finalHour;
      let finalMinutes =
        this.finalMinutes < 10 ? `0${this.finalMinutes}` : this.finalMinutes;

      return `${this.selectedDay}T${finalHour}:${finalMinutes}:59`;
    },
    selectedDate() {
      return [this.startDate, this.endDate];
    },
    checkMax() {
      let max = moment().format("YYYY-MM-DDTHH:mm:ss");
      if (this.max) max = moment(this.max).format("YYYY-MM-DDTHH:mm:ss");
      max = new Date(max).getTime();
      let selectedDay = moment(this.selectedDay).format("YYYY-MM-DDT23:59:59");
      selectedDay = new Date(selectedDay).getTime();
      return selectedDay - max >= 0 ? true : false;
    },
    checkMin() {
      if (!this.min) return false;
      let min = moment(this.min).format("YYYY-MM-DDTHH:mm:ss");
      min = new Date(min).getTime();
      let selectedDay = moment(this.selectedDay).format("YYYY-MM-DDT23:59:59");
      selectedDay = new Date(selectedDay).getTime();
      return selectedDay - min <= 0 ? true : false;
    },
  },
  methods: {
    moveFoward() {
      this.selectedDay = moment(this.selectedDay).add(1, "day").format("YYYY-MM-DD");
    },
    moveBack() {
      this.selectedDay = moment(this.selectedDay).add(-1, "day").format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped lang="scss">
.picker {
  height: 290px;
  width: 290px;
  padding: 0px 12px;
}
.picker-header {
  height: 48px;
  cursor: pointer;
}
.select-day {
  color: $dark;
}
.select-day:hover {
  color: $primary-light;
}
</style>
